/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Form } from '../../models/form';
import { FormCreateDto } from '../../models/form-create-dto';

export interface CreateForm$Params {
  body: FormCreateDto;
}

export function createForm(
  http: HttpClient,
  rootUrl: string,
  params: CreateForm$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Form>> {
  const rb = new RequestBuilder(rootUrl, createForm.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Form>;
    })
  );
}

createForm.PATH = '/forms';
